import React, { useEffect, useState } from "react";
import { getThemeByValue, ThemeType } from '../enums/config'
import GetQueryParam from '../hooks/getQuery'
import themes from '../utils/themes'
import { defaultProducts } from '../utils/products'
import MutualService from '../service/MutualService';
import { useCustomContext } from '../components/ContextHook';
import Config from "../model/config";
import Theme from '../model/theme';
import Products from '../model/product';
import testimonialsData from "../utils/testimonials";
import Testimonial from "../model/testimonial";


interface AuthContextType {
    handleTheme: (value: string) => void;
    themeType: ThemeType;
    config: Theme;
    products: Products[]
    testimonials: Testimonial[]
}

let AuthContext = React.createContext<AuthContextType>(null!);

export function useTheme() {
    return React.useContext(AuthContext);
}

export default function ThemeContext({ children }: { children: React.ReactNode }) {
    const [themeType, setThemeType] = useState<ThemeType>(ThemeType.default);
    const [config, setConfig] = useState<Theme>(themes[ThemeType.default]);
    const [products, setProducts] = useState<Products[]>(defaultProducts);
    const [testimonials, setTestimonials] = useState<Testimonial[]>(testimonialsData);

    const { setConfigContext } = useCustomContext();

    const queryTheme = GetQueryParam('theme');
    const endDate = GetQueryParam('end-date');

    useEffect(() => {
        (async () => {
            let themeType: ThemeType = ThemeType.default;
            let configs: Config = new Config();
            if (queryTheme === null) {
                configs = await MutualService.getConfigs();
                const { currentEvent } = configs;
                if (currentEvent) {
                    themeType = getThemeByValue(currentEvent.name);
                    setProducts(currentEvent.productList ?? defaultProducts);
                    setConfig(currentEvent.theme ?? themes[themeType]);
                    setTestimonials(currentEvent.testimonials ?? testimonialsData);
                }
            }
            else {
                themeType = getThemeByValue(queryTheme);
                if (themeType !== ThemeType.default) {
                    setProducts(defaultProducts)
                }
                setConfig(themes[themeType]);
            }
            setThemeType(themeType);
            if (endDate) {
                configs.currentEvent = { startDate: new Date(), endDate: new Date(endDate), name: themeType };
            }
            setConfigContext(configs);
        })();
    }, [setConfigContext, endDate, queryTheme])

    const handleTheme = (value: string): void => {
        setThemeType(value as ThemeType)
    }

    const value = { handleTheme, themeType, config, products, testimonials };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

